<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">创建时间</span>
        <el-date-picker
            v-model="date"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">所属行业</span>
        <el-cascader
            class="w150"
            clearable
            placeholder="不限"
            v-model="industry"
            :options="industryList"
            :props="{value: 'adIndustryId', label: 'industryName'}"
        />
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">广告类型</span>
        <el-select v-model="adType" class="w150" placeholder="不限" clearable>
          <el-option v-for="(item, index) in adTypeList" :key="index" :label="item.name" :value="item.id"/>
        </el-select>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">付费类型</span>
        <el-select v-model="costType" class="w150" placeholder="不限" clearable>
          <el-option v-for="(item, index) in costTypeList" :key="index" :label="item.name" :value="item.id"/>
        </el-select>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">广告标题</span>
        <el-input v-model.trim="title" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="pages.page = 1; getAdMinePageFn()">
          搜索
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="title" label="广告标题"></el-table-column>
      <el-table-column align="center" prop="adType.desc" label="广告类型"></el-table-column>
      <el-table-column align="center" prop="payType.desc" label="付费类型"></el-table-column>
      <el-table-column align="center" prop="adIndustryName" label="所属行业"></el-table-column>
      <el-table-column align="center" prop="totalCostLimit" label="总投入上限"></el-table-column>
      <el-table-column align="center" prop="dayCostLimit" label="日花费上限"></el-table-column>
      <el-table-column align="center" prop="status.desc" label="状态"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
      <el-table-column align="center" label="操作" width="250">
        <template slot-scope="{row}">
          <a class="glob-a" @click="closeBtn(1, row)">查看</a>
          <a class="glob-a" v-if="row.status && row.status.name == 'PUTTING'" @click="closeBtn(2, row)">结束投放</a>
          <template v-if="row.status && row.status.name == 'CLOSE' || row.status.name == 'REJECT'">
            <a class="glob-a" @click="closeBtn(3, row)">重新投放</a>
            <a class="glob-a" @click="closeBtn(4, row)">编辑</a>
            <a class="glob-a" @click="closeBtn(5, row)">删除</a>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <el-dialog title="查看" :visible.sync="msgModal" fullscreen>
      <detail :id="msgId"/>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getAdIndustryTree,
    getAdMinePage,
    delAd,
    setAdClose
  } from '@/api'

  import Detail from './Detail.vue'

  export default {
    name: 'AdPlatform',
    components: {Detail},
    data () {
      return {
        date: [],
        title: '',
        industry: '',
        industryList: [],
        adType: '',
        adTypeList: [
          {name: '通用广告', id: 'NORMAL'},
          {name: '商品广告', id: 'GOODS'},
          {name: '视频广告', id: 'VIDEO'},
          {name: '外链广告', id: 'OUT_LINK'}
        ],
        costType: '',
        costTypeList: [
          {name: '点击付费', id: 'CLICK'},
          {name: '拆红包付费', id: 'RED_PACKET'},
        ],
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        msgId: '',
        msgModal: false,
      }
    },
    created () {
      this.getAdMinePageFn()
      this.getAdIndustryTreeFn()
    },
    methods: {
      // t: 1查看 2结束投放 3重新投放 4编辑 5删除
      closeBtn (t, row) {
        switch (t) {
          case 1:
            this.msgId = row.advertisingId
            this.msgModal = true
            break
          case 2:
            this.$confirm('确认取消投放吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              setAdClose(row.advertisingId).then(res => {
                this.$message.success(res.data)
                this.getAdMinePageFn()
              })
            }).catch(() => {
            })
            break
          case 3:
            break
          case 4:
            break
          case 5:
            this.$confirm('确认删除吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              delAd(row.advertisingId).then(res => {
                this.$message.success(res.data)
                this.getAdMinePageFn()
              })
            }).catch(() => {
            })
            break
        }
      },
      getAdMinePageFn () {
        this.tableLoading = true
        getAdMinePage({
          payType: this.costType,
          title: this.title,
          pageNum: this.pages.page,
          startTime: this.date && this.date.length ? this.date[0] : '',
          endTime: this.date && this.date.length > 1 ? this.date[1] : '',
          adType: this.adType,
          adIndustryId: this.industry.length ? this.industry[this.industry.length - 1] : '',
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getAdMinePageFn()
      },
      getAdIndustryTreeFn () {
        getAdIndustryTree().then(res => {
          this.industryList = res.data.children
        })
      },
    }
  }
</script>

<style scoped>

</style>
